<template>
  <div>
   <AttendanceSummary :module_id="10" v-model="maximizeCard" />
   <vs-card class="cstm_vx_card mb-4">
      <vs-row>
        <vs-col
          vs-type="flex"
          vs-align="center"
          vs-lg="8"
          vs-sm="12"
          vs-xs="12"
        >
          <div class="md:w-1/2 w-full p-1">
            <vs-input placeholder="Search" v-model="search"
            @keyup="searchFun" class="w-full"></vs-input>
          </div>
          <div class="p-1">
            <vs-tooltip color="primary" text="Filter View" position="top">
              <vs-button
                color="primary"
                type="border"
                class="includeIcon includeIconOnly"
                @click="overallSearchHolder = !overallSearchHolder"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <rect width="18" height="18" fill="white" />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M11 14C12.6569 14 14 12.6569 14 11C14 9.34315 12.6569 8 11 8C9.34315 8 8 9.34315 8 11C8 12.6569 9.34315 14 11 14ZM11 15C13.2091 15 15 13.2091 15 11C15 8.79086 13.2091 7 11 7C8.79086 7 7 8.79086 7 11C7 13.2091 8.79086 15 11 15Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M15.1465 16.3536L13.1465 14.3536L13.8536 13.6465L15.8536 15.6465L15.1465 16.3536Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M0.5 3C0.5 1.61929 1.61929 0.5 3 0.5H15C16.3807 0.5 17.5 1.61929 17.5 3V14.5H16.5V3C16.5 2.17157 15.8284 1.5 15 1.5H3C2.17157 1.5 1.5 2.17157 1.5 3V15C1.5 15.8284 2.17157 16.5 3 16.5H13.5V17.5H3C1.61929 17.5 0.5 16.3807 0.5 15V3Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M16.5 5.5H1.5V4.5H16.5V5.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7.5 8.5H1.5V7.5H7.5V8.5ZM16.5 8.5H15V7.5H16.5V8.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M6.5 11.5H1.5V10.5H6.5V11.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7.5 14.5H1.5V13.5H7.5V14.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M4.5 16.5V5H5.5V16.5H4.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                </svg>
              </vs-button>
            </vs-tooltip>
          </div>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-align="center"
          vs-lg="4"
          vs-sm="12"
          vs-xs="12"
        >
        </vs-col>
      </vs-row>
    </vs-card>
    <vx-card v-if="overallSearchHolder" title="Select View" class="mb-4">
      <!-- <pre>{{courseList}}</pre> -->
      <div class="md:flex">
        <!-- {{selectedCourseId}} -->
        <div class="p-1 lg:w-1/3 w-full">
          <v-select
            append-to-body
            class="w-full"
            label="name"
            :reduce="(option) => option.id"
            :options="courseList"
            v-model="selectedCourseId"
            :clearable="true"
            placeholder="Enter Course Name"
          ></v-select>
        </div>
        <!-- <pre> {{courseList}}</pre> -->

        <div class="p-1 lg:w-1/3 w-full">
          <v-select
            append-to-body
            class="w-full"
            label="first_name"
            :reduce="(option) => option.id"
            :options="teacherList"
            v-model="teacherId"
            :clearable="false"
            placeholder="Enter Teacher Name"
          >
            <template v-slot:selected-option="teacherList">
                  <img
                    v-if="teacherList.picture"
                    class="person-img rounded-full"
                    :src="teacherList.picture"
                  />
                  <img
                    v-else
                    class="person-img rounded-full"
                    src="@/assets/images/pages/user-circle-solid.svg"
                  />
                  {{ teacherList.first_name }}
                  {{ teacherList.last_name }}
                </template>
            <template v-slot:option="teacherList">
                  <img
                    v-if="teacherList.picture"
                    class="person-img rounded-full"
                    :src="teacherList.picture"
                  />
                  <img
                    v-else
                    class="person-img rounded-full"
                    src="@/assets/images/pages/user-circle-solid.svg"
                  />
                  {{ teacherList.first_name }}
                  {{ teacherList.last_name }}
                </template>
          </v-select>
         
        </div>

        <div class="p-1 lg:w-1/3 w-full">
          <!--  <pre>{{students}}</pre> -->
          <!-- {{studentId}} -->
          <v-select
            append-to-body
            class="w-full"
            :getOptionLabel="(item) => `${item.first_name} ${item.last_name}`"
            :reduce="(option) => option.id"
            :options="students"
            v-model="studentId"
            :clearable="true"
            placeholder="Enter Student Name"
          >
            <template v-slot:selected-option="students">
                 <img
                    v-if="students.picture"
                    class="person-img rounded-full"
                    :src="students.picture"
                  />
                  <img
                    v-else
                    class="person-img rounded-full"
                    src="@/assets/images/pages/user-circle-solid.svg"
                  />
                  {{ students.first_name }}
                  {{ students.last_name }}
                </template>
            <template v-slot:option="students">
                  <img
                    v-if="students.picture"
                    class="person-img rounded-full"
                    :src="students.picture"
                  />
                  <img
                    v-else
                    class="person-img rounded-full"
                    src="@/assets/images/pages/user-circle-solid.svg"
                  />
                  {{ students.first_name }}
                  {{ students.last_name }}
                </template>
          </v-select>
        </div>
        <div class="p-1 lg:w-1/3 w-full">
          <v-select
            append-to-body
            class="w-full"
            label="first_name"
            :options="attendanceTypeOptions"
            v-model="attendanceType"
            :clearable="false"
            placeholder="Attendance Type"
          ></v-select>
          
        </div>
        <div class="p-1 lg:w-1/3 w-full">
          <flat-pickr
            class="w-full"
            v-model="attendance_date"
            :config="configdateTimePickerTest"
            placeholder="Attendance Date"
          ></flat-pickr>
        </div>

        <div class="p-1 flex">
            <vs-button class="includeIcon includeIconOnly" @click.prevent="filterGoMethod()">Go</vs-button>

          <!-- <vs-tooltip text="Reset">
                        <vs-button type="border" icon-pack="feather" icon="icon-refresh-ccw" class="ml-2"></vs-button>
                    </vs-tooltip> -->
        </div>
      </div>
    </vx-card>

    <!-- {{filterPayload}} -->
    <attendance-list :filterPayload="filterPayload"></attendance-list>
  </div>
</template>

<script>
import AttendanceSummary from '@/views/pages/analytics/summeryLIst.vue'
import vSelect from 'vue-select'
//you need to import the CSS manually
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { attendanceMixin } from './mixins/attendanceMixin'
import AttendanceList from './components/AttendanceList.vue'
export default {
  name: 'attendance',
  components: {
    vSelect,
    flatPickr,
    AttendanceList,
    AttendanceSummary
  },
  mixins: [attendanceMixin],
  data () {
    return {
      search:'',
      overallSearchHolder:false,
      maximizeCard:true,
      configdateTimePickerTest: {
        altInput: true,
        altFormat: 'j F, Y',
        // dateFormat: 'Y-m-d',
        wrap: true,
        dateFormat: 'Y-m-d'
      },
      filterPayload: {
        course_id: null,
        start_date: this.$moment(new Date()).format('YYYY-MM-DD'),
        end_date: this.$moment(new Date()).format('YYYY-MM-DD'),
        teacher_id: null,
        client_user_id: null,
        attendance_type:'All',
        search: ''
      }
    }
  },
  methods: {
    async searchFun () {
      this.fetchListBySearch(this)
    },
    fetchListBySearch: _.debounce(async (vm) => {
      try {
        vm.filterGoMethod()
      } catch (e) {
        console.log(e)
      }
    }, 1500),
    editAttendance (indextr) {
      indextr.attendance = ''
      indextr.delayed_num = null
      indextr.delayed_input = true
    },

    filterGoMethod () {
      
      this.filterPayload.course_id = this.selectedCourseId
      this.filterPayload.teacher_id = this.teacherId
      this.filterPayload.client_user_id = this.studentId
      this.filterPayload.start_date = this.attendance_date
      this.filterPayload.end_date = this.attendance_date
      this.filterPayload.attendance_type = this.attendanceType
      this.filterPayload.search = this.search

    }
  }
}
</script>
<style>
.attendance-badge {
  display: inline-block;
  margin: 5px 5px 5px 0;
  text-align: center;
  border-radius: 10rem;
  text-transform: capitalize;
  padding: 2px 10px;
  font-weight: 600;
}
.attendance-badge.present {
  background-color: rgba(40, 199, 111, 0.12);
  color: #28c76f !important;
}
.attendance-badge.absent {
  background-color: rgba(220, 53, 69, 0.12);
  color: #dc3545 !important;
}
.edit_att {
  font-size: 15px;
  cursor: pointer;
}
</style>